export default __webpack_public_path__ + "static/media/rice.3f02e897.jpg";